import React from 'react'; 
import { Button, Icon } from 'semantic-ui-react';
import { SearchBar } from 'dyl-components';
import '../index.scss';
import { USER_PERMISSIONS } from 'dyl-components';
import RestrictedView from 'shared/RestrictedView';

const Toolbar = ({ search, onSearchSubmit, cancelFunction, onChangeSearch, onOpenModal }) => {
    return (
        <div style={{display: 'flex'}}>
            <div style={{flex: 1}}>
                <SearchBar
                    isSearching={false}
                    search={search}
                    searchFcn={onSearchSubmit}
                    cancelFcn={cancelFunction}
                    placeholder='Search by prompt name or extension'
                    addClassNames='IvrPrompts__search'
                    onChange={onChangeSearch}
                    bottomError
                />
            </div>
            <div>
                <RestrictedView type='disabled' userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_ADD}>
                    <Button className='IvrPromptsToolbar__button' onClick={onOpenModal}>
                        <Icon name="plus" size='small' /> IVR Audio
                    </Button>
                </RestrictedView>
            </div>
        </div>

    )
}

export default Toolbar;
